module.exports = __webpack_public_path__ + "vue_assets/img/img_sectionheader_topbar.a71faca0.png";